import preparationListeMouvementClient from '@/services/remiseBancaire/reglement/preparationListeMouvementClient';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';

export default function preparationListePieces(pieces, mouvementClientReglement,
  remiseBancaireId) {
  if (remiseBancaireId !== null) {
    const index = pieces.findIndex((piece) => {
      return piece.pieceId === remiseBancaireId;
    });
    if (index !== -1) {
      pieces.splice(index, 1);
    }
  }
  pieces.forEach((piece) => {
    piece.inputAffecte = 0.0;
    piece.resteALettrer = 0.0;
    piece.restantALettrerTtc = 0.0;
    piece.solde = 0.0;
    piece.montantEscompte = 0.0;
    piece.escompteApplicable = false;
    if (piece.pieceType === mouvementClientConf.FACTURE
      && piece.facture.escompte === false
      && piece.facture.tauxEscompte !== null) {
      piece.montantEscompte = piece.montantPieceTtc * piece.facture.tauxEscompte / 100;
    }
    preparationListeMouvementClient(piece, piece.mouvementsClients, mouvementClientReglement);
  });
}
